var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 841.9 595.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0c6577;\n      }\n\n      .st1 {\n        fill: #80b149;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 228.6,
    y1: 297.6,
    x2: 322.5,
    y2: 297.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6d438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c6577"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.5,344.5c-11.8,0-23.1-4.4-31.9-12.5-1.5-1.4-1.8-3.6-.6-5.3,1.4-1.9,4.2-2.2,5.9-.6,7.3,6.8,16.8,10.5,26.7,10.5,21.5,0,39-17.5,39-39s-.2-4-.5-6c-1-6.4-6.7-11.3-13.3-11.3h-25.5c-7.7,0-14.3,5-16.5,12.2-.2.6.3,1.2.9,1.2h30.7c1.8,0,3.6.6,4.9,1.8s2.7,4.1,2.3,6.6c-2.1,12-12.5,20.7-24.8,20.7h-22.6c-10.6,0-19.5-7.7-21.1-18.2s-.6-5.3-.5-7.9c.5-25.6,21.8-46.3,47.4-46,11.7.1,22.8,4.6,31.4,12.6.2.2.4.4.7.6,1.5,1.4,1.8,3.7.5,5.3s-4.2,2.1-5.9.4c-.2-.2-.4-.4-.7-.6-7.1-6.6-16.4-10.3-26.1-10.5-21.4-.3-39.1,16.9-39.5,38.3,0,2.2,0,4.4.4,6.6,1,6.6,6.6,11.5,13.3,11.5h22.6c7.7,0,14.3-5,16.5-12.2.2-.6-.3-1.2-.9-1.2h-30.7c-1.8,0-3.6-.6-4.9-1.8s-2.7-4.1-2.3-6.6c2.1-12,12.6-20.7,24.8-20.7h25.5c10.4,0,19.5,7.7,21,17.9.4,2.4.6,4.8.6,7.2,0,25.9-21,46.9-46.9,46.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.4,315.5l3-6.8c3.8,3,9.8,5.2,15.6,5.2s10.4-2.6,10.4-6.1c0-10.2-28-3.5-28-21s6.1-14.1,19-14.1,11.6,1.5,15.7,4.2l-2.8,6.8c-4.2-2.5-8.9-3.7-13-3.7-7.3,0-10.2,2.8-10.2,6.4,0,10,27.9,3.5,27.9,20.8s-6.1,14-19.1,14-14.7-2.3-18.6-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.3,284.5v34.1c0,13.1-6.5,19-18.7,19s-12.8-1.8-16.8-5.1l3.8-6.3c3,2.6,7.7,4.2,12.5,4.2,7.4,0,10.7-3.6,10.7-10.8v-5.3c-2.7,3-6.7,4.6-11.2,4.6-9.2,0-15.5-5-15.5-15.9v-18.5h8.4v17.4c0,6.5,3.1,9.6,8.4,9.6s9.8-3.6,9.8-10.8v-16.2h8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.4,299.9v20.6h-8.4v-19.5c0-6.4-3.2-9.5-8.6-9.5s-10,3.6-10,10.8v18.2h-8.4v-36h8v4.6c2.8-3.3,7.1-5.1,12.4-5.1,8.6,0,15,4.9,15,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.2,302.5c0-10.8,8.1-18.4,19.1-18.4s19.2,7.6,19.2,18.4-8,18.5-19.2,18.5-19.1-7.7-19.1-18.5ZM488,302.5c0-6.9-4.6-11.2-10.7-11.2s-10.6,4.4-10.6,11.2,4.6,11.2,10.6,11.2,10.7-4.4,10.7-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.9,284.5l-15.4,36h-8.7l-15.4-36h8.8l11.2,26.7,11.5-26.7h8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.9,284.5v36h-8v-4.6c-2.8,3.4-7,5.1-11.9,5.1-10.5,0-18.2-7.3-18.2-18.5s7.7-18.4,18.2-18.4,8.6,1.5,11.5,4.8v-4.4h8.4ZM561.6,302.5c0-6.9-4.6-11.2-10.7-11.2s-10.6,4.4-10.6,11.2,4.6,11.2,10.6,11.2,10.7-4.4,10.7-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613,299.9v20.6h-8.4v-19.5c0-6.4-3.2-9.5-8.6-9.5s-10,3.6-10,10.8v18.2h-8.4v-50h8.4v18.2c2.8-3,7-4.6,12-4.6,8.6,0,15,4.9,15,15.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.7,326.4v10.3h-1.5v-4.6h-5.9v4.6h-1.5v-10.3h1.5v4.4h5.9v-4.4h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.4,335.4v1.3h-7.5v-10.3h7.3v1.3h-5.8v3.2h5.2v1.2h-5.2v3.3h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M527.5,334.1h-5.5l-1.1,2.6h-1.5l4.7-10.3h1.5l4.7,10.3h-1.5l-1.1-2.6ZM527,333l-2.2-5-2.2,5h4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.9,326.4h1.5v9h5.6v1.3h-7v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.9,327.7h-3.5v-1.3h8.5v1.3h-3.5v9h-1.5v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563.5,326.4v10.3h-1.5v-4.6h-5.9v4.6h-1.5v-10.3h1.5v4.4h5.9v-4.4h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M570.8,327.7h-3.5v-1.3h8.5v1.3h-3.5v9h-1.5v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.1,335.4v1.3h-7.5v-10.3h7.3v1.3h-5.8v3.2h5.2v1.2h-5.2v3.3h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M590.8,331.6c0-3,2.3-5.3,5.4-5.3s3,.5,3.9,1.6l-1,.9c-.8-.8-1.8-1.2-2.9-1.2-2.3,0-4,1.7-4,3.9s1.7,3.9,4,3.9,2.1-.4,2.9-1.2l1,.9c-.9,1.1-2.3,1.6-3.9,1.6-3.1,0-5.4-2.2-5.4-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,326.4v10.3h-1.5v-4.6h-5.9v4.6h-1.5v-10.3h1.5v4.4h5.9v-4.4h1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92ba198d0ffa0869bc567bc91f14611f.svg";
export { ForwardRef as ReactComponent };